/**
 * sidebar-collapse.js
 *
 * Collapses the desktop section-nav sidebar (#sidebar) down to a 44px rail and
 * back. The toggle button lives at the sidebar's top-right (hidden until hover;
 * see sections/sidebar.html). Collapsing adds `.is-collapsed`, which hides the
 * nav body and leaves only the (flipped) chevron. State persists in
 * localStorage so it survives reloads.
 */

const STORAGE_KEY = 'stance:sidebar-collapsed';

const sidebar = document.getElementById('sidebar');
const toggle = sidebar?.querySelector('[data-sidebar-toggle]');

if (sidebar && toggle) {
  const apply = (collapsed) => {
    sidebar.classList.toggle('is-collapsed', collapsed);
    toggle.setAttribute('aria-expanded', String(!collapsed));
    toggle.setAttribute('aria-label', collapsed ? 'Expand sidebar' : 'Collapse sidebar');
  };

  // Restore the last state (applied immediately — the module is deferred, so the
  // DOM is already parsed).
  apply(localStorage.getItem(STORAGE_KEY) === '1');

  toggle.addEventListener('click', () => {
    const collapsed = !sidebar.classList.contains('is-collapsed');
    apply(collapsed);
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch {
      /* storage may be unavailable (private mode) — ignore */
    }
  });
}
